import { Heading } from '../../../../../../../components/Heading/Heading';
import { WarningIcon } from '../../../../../../../components/Icons/WarningIcon';
import { RegulationLocationContent } from '../../../../../../../components/RegulationLocationCard/RegulationLocationContent';
import { Text } from '../../../../../../../components/Text/Text';
import { IBoundary } from '@domain/regulations/hooks/useRegulationBoundaryAtLocation';
import { ICoordinates } from '@app-types/geo';

interface IRegulationListHeaderProps {
  boundaries: IBoundary[] | undefined;
  coordinates: ICoordinates | undefined;
  boundaryName: string | undefined;
  isProhibited: boolean;
  message: string | undefined;
}

export const RegulationViewHeader = ({
  boundaries,
  coordinates,
  boundaryName,
  isProhibited,
  message,
}: IRegulationListHeaderProps) => {
  return (
    <div className="bg-lake-fog flex flex-col">
      <Heading variant="sm">Regulations</Heading>
      <div className="pb-4">
        {boundaries && boundaries.length > 0 && (
          <RegulationLocationContent
            coordinates={coordinates}
            boundaryName={boundaryName}
            boundaries={boundaries}
          />
        )}
        {isProhibited && (
          <div className="mb-6">
            <div className="flex items-center">
              <WarningIcon />
              <Text variant="md" className="text-error-shade mb-0 ml-1">
                Protected area
              </Text>
            </div>
            <Text className="text-error-shade my-6" variant="md">
              {message ?? 'It is unlawful to fish in these waters'}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};
